import hechterTailored from './HechterTailored.jpeg';

export const hechterTailoredImpressions = {
    hechterTailored,
};
